<template>
  <div class="all-question-outer">
      <div class="sign">
          <div class="cancelSign" @click="cancelSign(questionData)">
              <img src="../../../../assets/cancelSign.png" alt="">
              <span>取消标记</span>
          </div>
          <div class="addSign" @click="addSign(questionData)">
              <img src="../../../../assets/addSign.png" alt="">
              <span>标记此题</span>
          </div>
      </div>
      <div class="question" v-if="questionData">
          <div class="questionTop">
              <span class="title">「填空题」</span>
              
              <span class="questionName">{{questionData.data.num}}、<span v-html="questionData.data.content"></span></span>
          </div>
          <ul>
            <li v-for="item in questionData.blanks" :key="item.blank1Id">
                <span>{{item.blankId}}空答案为：</span>
                <a-textarea  v-model="value[item.blankId-1]" class="textarea" placeholder="请输入内容" auto-size @change="onChange(questionData)" />
            </li>
          </ul>
      </div>
  </div>
</template>

<script>
export default {
    name:"fillBlanks",
    props:['questionData'],
    data(){
        return{
            value: this.questionData.myAnswer?this.questionData.myAnswer:null,
        }
    },
    methods:{
        onChange(val) {
            val.isAnswer = true;
        },
        //取消标记
        cancelSign(val){
            val.form.is_sign = "2";
            this.$forceUpdate()
        },
        //标记此题
        addSign(val){
            val.form.is_sign = "1";
            this.$forceUpdate()
        }
    }

}
</script>

<style scoped lang="less">
.all-question-outer {
    width: 100%;
    height: calc(100% - 60px);
    padding: 20px 50px 30px 50px;
    overflow-y: auto;
}
.sign{
    height: 32px;
    margin-left: 500px;
}
.sign img{
     width: 16px;
    height: auto;
    margin-right: 4px;
    display: inline-block;
    vertical-align: -3px;
}
.cancelSign{
    float: right;
    display: flex;
    align-items: center;
    cursor: pointer;
}
.cancelSign span{
    width: 57px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #F79E3F;
    line-height: 32px;
}
.addSign{
    float: right;
    display: flex;
    align-items: center;
    cursor: pointer;
}
.addSign span{
    width: 57px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #666666;
    line-height: 32px;
}
.question .title{
    width: 371px;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #333333;
    line-height: 32px;
}
.question .questionName{
    width: 92px;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #14202C;
    line-height: 32px;
}
.questionTop{
    width: 100%;
    padding: 15px 0 0;
    /deep/img {
        display: block;
        max-width: 100%;
        height: auto;
    }
}
li{
    margin-bottom: 20px;
}
ul{
    margin-top: 10px;
}
li .textarea{
    width: 85%;
}
li span{
  line-height: 32px;
}
</style>